import styled from "@emotion/styled";
import { oneOf, oneOfType, shape, string } from "prop-types";
import React from "react";

import theme from "../../../theme";
import { ImageDataType } from "../../ImageComponent";

const Wrapper = styled.div`
  position: relative;
  flex: 1 0 100%
  display: flex;
  justify-content: center;
  align-items: center;
  scroll-snap-align: start;
  padding: ${theme.space("l")};
  min-width: 100%;
`;

const Image = styled.div`
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
  background-image: url(${({ url }) => url});
  background-size: cover;
  background-position: center;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio} / 1;
  @supports not (aspect-ratio: ${({ aspectRatio }) => aspectRatio} / 1) {
    &::before {
      float: left;
      padding-top: ${({ aspectRatio }) => (1 / aspectRatio) * 100}%;
      content: "";
    }

    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }
`;

function AwardGif({ image, ...props }) {
  return (
    <Wrapper {...props}>
      <Image url={image.url} aspectRatio={image.data.aspectRatio} />
    </Wrapper>
  );
}

export const awardGif = {
  image: shape({
    url: string,
    data: oneOfType([oneOf([null]), shape(ImageDataType)]),
  }),
};

AwardGif.propTypes = {
  ...awardGif,
};

AwardGif.defaultProps = {};

export default AwardGif;
